const bankAccountTypes = {
  237: [
    {
      value: 'corrente',
      text:  'Conta Corrente Individual - 01',
    },
    {
      value: 'poupança',
      text:  'Conta Poupança Individual - 02',
    },
  ],
  104: [
    {
      value: '001',
      text:  'Conta corrente - 001',
    },
    {
      value: '013',
      text:  'Conta poupança - 013',
    },
    {
      value: '023',
      text:  'Conta simplificada - 023',
    },
    {
      value: '3701',
      text:  'Conta corrente (nova numeração) - 3701',
    },
    {
      value: '1288',
      text:  'Conta poupança (nova numeração) - 1288',
    },
  ],
};
export default bankAccountTypes;
